  //Core Firebase service that handles data storage and retrieval
  
  import { initializeApp } from 'firebase/app';
  import { getStorage, ref, uploadString, getDownloadURL } from 'firebase/storage';
  import { getFirestore, collection, addDoc, doc, getDoc, serverTimestamp } from 'firebase/firestore';
  
  const firebaseConfig = {
    apiKey: "AIzaSyCDjdaZzKUqcc_SkgzwwzWJ11BZFFjTj0Y",
    authDomain: "unrecordbenchmark.firebaseapp.com",
    projectId: "unrecordbenchmark",
    storageBucket: "unrecordbenchmark.firebasestorage.app",
    messagingSenderId: "1098192714378",
    appId: "1:1098192714378:web:a2b365606d82f26b1bcb73"
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const storage = getStorage(app);
  const db = getFirestore(app);
  
  /**
   * Uploads benchmark data and returns a shareable ID
   * @param {Object} benchmarkData The benchmark data to upload
   * @returns {Promise<string>} A unique ID for retrieving the data
   */
  export async function uploadBenchmarkData(benchmarkData) {
    try {
      // Create a reference to the benchmark data in Firestore
      const benchmarkRef = await addDoc(collection(db, "benchmarks"), {
        createdAt: serverTimestamp(),
        fileName: benchmarkData.fileName || 'unknown',
        expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000), // Expire in 30 days
      });
      
      const benchmarkId = benchmarkRef.id;
      
      // Convert benchmark data to JSON string
      const dataString = JSON.stringify(benchmarkData);
      
      // Upload the data to Firebase Storage
      const storageRef = ref(storage, `benchmarks/${benchmarkId}`);
      await uploadString(storageRef, dataString, 'raw');
      
      return benchmarkId;
    } catch (error) {
      console.error("Error uploading benchmark data:", error);
      throw error;
    }
  }
  
  /**
   * Retrieves benchmark data by ID
   * @param {string} benchmarkId The unique ID of the benchmark data
   * @returns {Promise<Object>} The benchmark data
   */
  export async function getBenchmarkData(benchmarkId) {
    try {
      // Check if the benchmark exists in Firestore
      const benchmarkRef = doc(db, "benchmarks", benchmarkId);
      const docSnap = await getDoc(benchmarkRef);
      
      if (!docSnap.exists()) {
        throw new Error("Benchmark data not found or has expired");
      }
      
      // Get the data from Firebase Storage
      const storageRef = ref(storage, `benchmarks/${benchmarkId}`);
      const url = await getDownloadURL(storageRef);
      
      // Fetch the data
      const response = await fetch(url);
      const dataString = await response.text();
      
      // Parse and return the data
      return JSON.parse(dataString);
    } catch (error) {
      console.error("Error retrieving benchmark data:", error);
      throw error;
    }
  }
  
  /**
   * Generates a shareable URL for the benchmark data
   * @param {string} benchmarkId The unique ID of the benchmark data
   * @returns {string} A URL that can be shared with others
   */
  export function getShareableUrl(benchmarkId) {
    return `${window.location.origin}${window.location.pathname}?benchmark=${benchmarkId}`;
  }